import { faHome } from '@fortawesome/pro-light-svg-icons'

import { DashboardModule } from '@domain-group/suit-theme'

import useReduxAction from '@hooks/useReduxAction'

import type { CampaignModel } from '@models/types'

import { ModuleState } from '@redux/modules/module'

import CampaignListItem from './CampaignListItem'

export const icon = faHome

export const configOptions = () => ({
  display_mode: {
    component: 'select',
    key: 'display_mode',
    label: 'Display Mode',
    optionKey: 'customization',
    values: [
      { key: 'compact-list', label: 'List (Compact)' },
      { key: 'large-list', label: 'List (Large)' },
    ],
  },
  limit: {
    component: 'select',
    key: 'limit',
    label: 'Limit',
    optionKey: 'queryParams',
    values: [
      { key: 10, label: '10' },
      { key: 25, label: '25' },
      { key: 50, label: '50' },
    ],
  },
})

interface RecentCampaignProps {
  customOptions: {
    queryParams: {
      limit?: number,
    },
    customization: {
      display_mode?: string,
    },
    },
}

const RecentCampaigns = (props: RecentCampaignProps) => {
  const {
    customOptions,
    customOptions: {
      queryParams,
    },
  } = props

  const { limit } = queryParams || {}

  const { customization } = customOptions
  const { display_mode } = customization || {}

  const requestOptions = {
    include_campaign_agency: true,
    include_campaign_image: true,
    include_campaign_paths: true,
  }

  const performHttpRequests = true

  const { loading: isLoading, data: campaigns } = useReduxAction(
    'campaigns',
    'loadCampaigns',
    {
      ...requestOptions,
      limit,
    },
    [performHttpRequests, limit],
    { shouldPerformFn: ({ loading }: ModuleState) => performHttpRequests && !loading, skipLoadedForKeysCheck: true },
  )

  return (
    <DashboardModule
      boxProps={{ marginBottom: 0 }}
      contentBoxProps={{ flexDirection: 'column' }}
      loading={isLoading}
      title="Recent Campaigns"
    >
      {/*
       // @ts-expect-error TS2339 */}
      {(!isLoading && campaigns?.length < 1) && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Campaigns Present.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.ScrollableSection>
        {/*
         // @ts-expect-error TS2339 */}
        {!isLoading && campaigns?.map((campaign: CampaignModel) => (
          <CampaignListItem key={campaign.id} campaign={campaign} displayMode={display_mode} />
        ))}
      </DashboardModule.ScrollableSection>
    </DashboardModule>
  )
}

export default RecentCampaigns
